import {isElectron} from "react-device-detect";
import {getLocaleId} from "./locale-selector";
import configApp from "../config/config";
import {saveEmployeeProps, saveStructure} from "./lamp";
import lampManage from "./lamp-manage";

const initialState = {
    initialized: false,
    errors: null,
    notices: null,
    theme_name: 'default_theme',
    document_title: 'Lamp',
    logo: `${configApp.app_dir}assets/img/logo.png`,
    logo_negative: `${configApp.app_dir}assets/img/logo.png`,
    favicon: `${configApp.app_dir}favicon.ico`,
    modules: [],
    settings: {
        server_host: '',
        fullscreen: false,
        cursor: false,
        window_name: '',
    }
}

export const INITIALIZED_SUCCESS = 'INITIALIZED_SUCCESS';
export const DOCUMENT_TITLE = 'DOCUMENT_TITLE';
export const FATAL_ERROR = 'FATAL_ERROR';
export const NOTICE_ERROR = 'NOTICE_ERROR';
export const DEFAULT_STATE_APP = 'DEFAULT_STATE_APP';
export const SET_THEME = 'SET_THEME';
export const SET_LOGO = 'SET_LOGO';
export const SET_LOGO_NEGATIVE = 'SET_LOGO_NEGATIVE';
export const SET_FAVICON = 'SET_FAVICON';
export const SET_MODULES = 'SET_MODULES';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const SAVE_SETTINGS = 'SAVE_SETTINGS';

export default function appReducer(state = initialState, action) {
    switch (action.type) {
        case INITIALIZED_SUCCESS:
            return {
                ...state,
                initialized: true
            };
        case NOTICE_ERROR:
            return {
                ...state,
                notices: action.errors
            };
        case FATAL_ERROR:
            return {
                ...state,
                initialized: true,
                errors: action.errors
            };
        case CLEAR_ERRORS:
            return {
                ...state,
                errors: null
            };
        case SET_THEME:
            return {
                ...state,
                theme_name: action.theme_name,
            };
        case SET_LOGO:
            return {
                ...state,
                logo: action.logo,
            };
        case SET_FAVICON:
            return {
                ...state,
                favicon: action.favicon,
            };
        case SET_MODULES:
            return {
                ...state,
                modules: action.modules,
            }
        case SET_LOGO_NEGATIVE:
            return {
                ...state,
                logo_negative: action.logo_negative,
            };
        case DOCUMENT_TITLE:
            return {
                ...state,
                document_title: action.document_title
            };
        case DEFAULT_STATE_APP:
            return {
                ...initialState,
                theme_name: state.theme_name,
                logo: state.logo,
                logo_negative: state.logo_negative,
                favicon: state.favicon,
                settings: state.settings,
            };
        case SAVE_SETTINGS:
            return {
                ...state,
                settings: action.settings
            }
        default:
            return state;
    }
}


export const errorApp = (dispatch, e) => {
    if (isElectron) {
        try {
            const logger = require('electron-log');
            logger.error({error: e});
        } catch (e) {
            console.error(e)
        }
    }
    dispatch(fatalError(e));
}

export const noticeApp = (dispatch, e) => {
    if (isElectron) {
        try {
            const logger = require('electron-log');
            logger.error({error: e});
        } catch (e) {
            console.log(e)
        }
    }
    dispatch(noticeError(e));
}